<template>
  <v-card
    class="mx-auto"
    max-width="600"
  >
    <v-system-bar
      color="indigo darken-2"
      dark
    >
    </v-system-bar>
    <v-toolbar
      color="indigo"
      dark
    >
      <v-toolbar-title>Recarga ID: 00{{ recharge.id }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="headline font-weight">
      <p><b>ID#: </b> {{ recharge.id }}</p>
      <p><b>Valor: </b> {{ $n((setAmount(recharge.amount)), 'currency') }}</p>
      <p><b>Operadora: </b> {{ recharge.provider }}</p>
      <p><b>Código de área: </b> {{ recharge.area_code }}</p>
      <p><b>NSU: </b> {{ recharge.nsu }}</p>
      <p><b>Celular: </b> {{ recharge.cell_phone_number }}</p>
      <p><b>Status: </b> <v-chip small :class="`${recharge.status} white--text my-2 caption`">{{ setStatus(recharge.status) }}</v-chip></p>
      <p><b>Código de autorização: </b> {{ recharge.authorization_code }}</p>
      <p><b>Pin: </b> {{ recharge.pin }}</p>
      <p><b>Data: </b> {{ setDateFormat(recharge.created_at) }}</p>
      <p><b>Hora: </b> {{ setTimeFormat(recharge.created_at) }}</p>
    </v-card-text>
    <v-card-actions>
      <v-btn
          color="indigo darken-2"
          dark
          @click.stop="goTo('recharges')"
        >
        Voltar
      </v-btn>
      <v-btn v-show="showConfirm"
          color="success"
          dark
          @click="confirmRecharge"
        >
        Confirmar
      </v-btn>
      <v-btn v-show="showCancel"
          color="red"
          dark
          @click="cancelRecharge"
        >
        Cancelar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Recharge',
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      isLoad: 'recharges/isLoad',
      recharge: 'recharges/recharge',
      showConfirm: 'recharges/showConfirm',
      showCancel: 'recharges/showCancel'
    }),
  },
  created() {
    this.$store.dispatch('recharges/show', parseInt(this.$route.params.id));
  },
  components: {

  },
  methods: {
    confirmRecharge() {
      this.$store.dispatch('recharges/showConfirm', false);
      this.$store.dispatch('recharges/showCancel', false);
      this.$store.dispatch('recharges/showLoad', true);
      this.$store.dispatch('recharges/confirm', this.recharge.id)
      this.$store.dispatch('recharges/showLoad', false);
      this.$router.push({ name: 'recharges' })
    },
    cancelRecharge() {
      this.$store.dispatch('recharges/showConfirm', false);
      this.$store.dispatch('recharges/showCancel', false);
      this.$store.dispatch('recharges/showLoad', true);
      this.$store.dispatch('recharges/cancel', this.recharge.id)
      this.$store.dispatch('recharges/showLoad', false);
      this.$router.push({ name: 'recharges' })
    },
    setStatus(status){
      if (status === "authorized") {
        return "Autorizado"
      }
      if (status === "captured") {
        return "Confirmado"
      }
      if (status === "refunded") {
        return "Cancelado"
      }
      if (status === "cancelled") {
        return "Cancelado"
      }
    },
    setAmount(amount){
      return (amount / 100)
    },
    setDateFormat(date) {
      if (date === null) {
        return ''
      } else {
        return new Date(date).toLocaleDateString("pt-BR")
      }
    },
    setTimeFormat(date) {
      if (date === null) {
        return ''
      } else {
        return new Date(date).toLocaleTimeString("pt-BR")
      }
    },
    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },
  },
  watch: {
    showConfirm(value) {
      this.showConfirm = value;
    },
    showCancel(value) {
      this.showCancel = value;
    },
    recharge(value) {

    }
  },
};
</script>
<style>
  .v-chip.captured{
    background: #3cd1c2;
  }
  .v-chip.authorized{
    background: #ffaa2c;
  }
  .v-chip.refunded{
    background: #f83e70;
  }
  .v-chip.cancelled{
    background: #f83e70;
  }
</style>
